const heroStats = [
  { value: "1,280+", label: "件已复盘事件" },
  { value: "37", label: "位常驻分析作者" },
  { value: "19.6 万", label: "每周社区讨论" },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full">
      <div className="relative w-full h-[600px] md:h-[720px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20moody%20dark%20editorial%20still%20life%20of%20scattered%20paper%20documents%20and%20glowing%20amber%20threads%20connecting%20clues%20on%20a%20deep%20charcoal%20wooden%20desk%2C%20warm%20rim%20lighting%2C%20cinematic%20haze%2C%20high%20contrast%20with%20large%20empty%20negative%20space%20in%20the%20center%20for%20text%2C%20artistic%20conceptual%20photography%2C%20no%20text&width=1600&height=900&seq=hlkd-hero-01&orientation=landscape"
          alt="黑料看点 深度解读 事件背后复盘拆解 细节分析 主视觉"
          title="黑料看点 深度解读与复盘拆解"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/65 to-foreground-950/85" />

        <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-8 text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-300/50 bg-primary-500/10 px-4 py-1.5 text-xs md:text-sm text-primary-200 animate-fade-in">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-float-slow" />
            本期焦点 · 深度解读进行中
          </span>

          <h1 className="mt-6 md:mt-8 font-heading font-black text-background-50 text-3xl md:text-5xl lg:text-6xl leading-tight tracking-tight max-w-4xl animate-fade-up">
            从蛛丝马迹到完整脉络，
            <br className="hidden md:block" />
            把事件背后的逻辑讲明白
          </h1>

          <p className="mt-5 md:mt-6 max-w-2xl text-sm md:text-base text-background-200 leading-relaxed animate-fade-up">
            黑料看点专注深度解读与复盘拆解：还原时间线、对齐每一句公开表态、标注每个细节的出处，
            多角度呈现观点碰撞，帮你理清争议焦点，吃瓜也能吃出门道。
          </p>

          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center gap-3 animate-fade-up">
            <a
              href="#download"
              className="w-full sm:w-auto whitespace-nowrap rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-7 py-3 transition-colors cursor-pointer"
            >
              下载 App 看完整复盘
            </a>
            <a
              href="#deep"
              className="w-full sm:w-auto whitespace-nowrap rounded-md border border-background-50/35 hover:border-background-50/70 text-background-50 text-sm font-medium px-7 py-3 transition-colors cursor-pointer"
            >
              进入深度解读
            </a>
          </div>

          <div className="mt-12 md:mt-16 w-full max-w-3xl grid grid-cols-3 divide-x divide-background-50/15">
            {heroStats.map((s) => (
              <div key={s.label} className="px-2 md:px-6">
                <div className="font-heading text-xl md:text-3xl font-bold text-background-50">
                  {s.value}
                </div>
                <div className="mt-1 text-[11px] md:text-xs text-background-300">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-background-50 to-transparent" />
      </div>
    </section>
  );
}